import React from 'react';
import { useParams } from 'react-router-dom';
import { extractIdFromPath } from '@/utils';
import Matrix from './Matrix';

export default function MatrixWrapper() {
    const { matrixPath } = useParams();
    return <Matrix matrixId={extractIdFromPath(matrixPath)} />;
}
